var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 51,
    viewBox: "0 0 41 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2429 20.8766C40.2151 20.8766 41 21.6736 41 22.6556C41 33.5487 32.7423 42.5162 22.2579 43.4257L22.2571 49.2209C22.2571 50.203 21.4699 51 20.5 51C19.5301 51 18.7429 50.203 18.7429 49.2209L18.7445 43.4259C8.25889 42.5175 0 33.5495 0 22.6556C0 21.6736 0.7872 20.8766 1.75714 20.8766C2.72943 20.8766 3.51429 21.6736 3.51429 22.6556C3.51429 32.1867 11.1333 39.9434 20.5 39.9434C29.8667 39.9434 37.4857 32.1867 37.4857 22.6556C37.4857 21.6736 38.2729 20.8766 39.2429 20.8766ZM20.5 0C26.7156 0 31.7738 5.14033 31.7738 11.4596V22.58C31.7738 28.8968 26.7156 34.0372 20.5 34.0372C14.2844 34.0372 9.22617 28.8968 9.22617 22.58V11.4596C9.22617 5.14033 14.2844 0 20.5 0ZM20.5 3.55814C16.2219 3.55814 12.7405 7.10205 12.7405 11.4596V22.58C12.7405 26.9327 16.2219 30.479 20.5 30.479C24.7781 30.479 28.2595 26.9327 28.2595 22.58V11.4596C28.2595 7.10205 24.7781 3.55814 20.5 3.55814Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEnabled);
export default __webpack_public_path__ + "static/media/audioEnabled.1fd89dfd9067cb071ec138a43f478249.svg";
export { ForwardRef as ReactComponent };